import { render, staticRenderFns } from "./AtividadesPrincipais.vue?vue&type=template&id=00222d80&scoped=true&"
import script from "./AtividadesPrincipais.vue?vue&type=script&lang=js&"
export * from "./AtividadesPrincipais.vue?vue&type=script&lang=js&"
import style0 from "./AtividadesPrincipais.vue?vue&type=style&index=0&id=00222d80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00222d80",
  null
  
)

export default component.exports